// Shared helper for the forfait-protection Polymarket buy ceiling
// (`forfaitPolyMaxBuyPrice`). Used by the opener row (EntryTabByPath) and the
// subgroup config dialog so the row and the snapshot that Apply stamps onto
// every member rule validate the SAME lever identically.

// Parse a raw cap input string to the value we persist:
//   - blank             -> null      (inherit the engine default)
//   - a price in (0, 1) -> the number
//   - anything else     -> undefined (INVALID; the caller must NOT save)
// Three-valued like `parseWalkInput`, so an invalid cap can abort a whole
// commit instead of shipping a partial write. A cap of 0 or ≥ 1 is not a
// ceiling on a prediction-market price — at ≥ 1 the brake could never suspend
// anything — so it is rejected rather than clamped.
export function parseForfaitCapInput(
  input: string
): number | null | undefined {
  const trimmed = input.trim();
  if (trimmed === '') return null;
  const n = Number(trimmed);
  if (Number.isFinite(n) && n > 0 && n < 1) return n;
  return undefined;
}
